<template>
  <div class="pos">
    <img alt="Vue logo" src="../assets/logo.png">
    <SetPOS  v-if="this.$store.state.PosId == null"/>
    <UserCardreader v-else/>
  </div>
</template>

<script>
// @ is an alias to /src
import SetPOS from '@/components/SetPos.vue'
import UserCardreader from '@/components/UserCardreader.vue'

export default {
  name: 'SetupPos',
  components: {
    SetPOS,
    UserCardreader
  },
  data() {
        return {
            posID: ''        
        }
    }
}
</script>
